import React from 'react';

import { FilterList as FilterListIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { Popover } from 'src/components/common';
import { useDashboardCVAdminData } from 'src/hooks/dashboard';

import { DASHBOARD_FILTER_CV_ADMIN_POPOVER_ANCHOR_GAP } from './constants';
import { DashboardFilterCVAdminCustomForm } from './DashboardFilterCVAdminCustomForm';
import {
  DASHBOARD_FILTER_CV_ADMIN_BUTTON_END_ICON_STYLES,
  DASHBOARD_FILTER_CV_ADMIN_BUTTON_STYLES,
} from './styles';
import { DashboardFilterCVAdminCustomFormValues } from './types';

export const DashboardFilterCVAdminCustomButton: React.FC<{
  getAnchorRef: () => Nullable<HTMLElement>;
  disabled?: boolean;
}> = ({ getAnchorRef, disabled }) => {
  const { setEmployers, setPeos, employers, peos } = useDashboardCVAdminData();

  const handleSubmit = React.useCallback(
    (customFilters: DashboardFilterCVAdminCustomFormValues) => {
      setPeos(customFilters.filters.PEO);
      setEmployers(customFilters.filters.employer);
    },
    [setPeos, setEmployers],
  );

  const renderPopoverContent = React.useCallback(
    ({ onClose }: { onClose: () => void }) => (
      <DashboardFilterCVAdminCustomForm
        onSubmit={handleSubmit}
        onClose={onClose}
        initialValues={{
          filters: {
            employer: employers ?? [],
            PEO: peos ?? [],
          },
        }}
      />
    ),
    [employers, peos, handleSubmit],
  );

  const buttonText =
    !peos?.[0] && !employers?.[0]
      ? 'All data'
      : `Scoped to ${[...(peos?.length ? [`${peos.length} PEO${peos.length > 1 ? 's' : ''}`] : []), ...(employers?.length ? [`${employers.length} employer${employers.length > 1 ? 's' : ''}`] : [])].join(' and ')}`;

  return (
    <Popover
      anchorPosition={{ left: 0, top: 0 }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ mt: DASHBOARD_FILTER_CV_ADMIN_POPOVER_ANCHOR_GAP }}
      anchorEl={getAnchorRef()}
      target={
        <Button
          disabled={disabled}
          variant="text"
          endIcon={<FilterListIcon fontSize="small" />}
          style={DASHBOARD_FILTER_CV_ADMIN_BUTTON_STYLES}
          sx={DASHBOARD_FILTER_CV_ADMIN_BUTTON_END_ICON_STYLES}
        >
          {buttonText}
        </Button>
      }
      content={renderPopoverContent}
    />
  );
};
